














import { defineComponent, PropType } from '@vue/composition-api';
import { MultiJumpContainer } from '@tencent/wphk-components-multi-jump-container';
import { HomeBanner } from '@/types/home';
import { useJumpInfo } from '../use-jumpinfo';

export default defineComponent({
  name: 'RightBottomBanner',
  components: {
    MultiJumpContainer,
  },
  props: {
    rightBottomBanner: {
      type: Object as PropType<HomeBanner>,
      required: false,
    },
  },
  setup(props) {
    const { jumpInfo } = useJumpInfo(props.rightBottomBanner);
    return {
      jumpInfo,
    };
  },
});
